import React from "react";
//#region types
import { DisplayProps, WintFormFieldProps } from "models/propTypes/wintFormPropsTypes";
//#endregion
//#region components
import FormFieldLayout from "./formFieldLayout";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";

export type FormFieldProps<T extends DisplayProps> = WintFormFieldProps & T;

function ReadOnlyFormField<T extends DisplayProps>(props: FormFieldProps<T>) {
  const {
    className,
    styles,
    direction,
    autogeneratedText,
    hideMainLabel,
    Component,
    name,
    value,
    error,
    hasError,
    label,
    controlLabel,
    descriptionText,
    customMessage,
    ...componentProps
  } = props;

  const actualLabel = typeof label === "string" ? LocalizationHelperInstance.getFormattedMessage(label, label) : label;

  return (
    <FormFieldLayout {...props}>
      <Component name={name} value={value} error={error} hasError={hasError} label={actualLabel} {...componentProps} />
    </FormFieldLayout>
  );
}

export default ReadOnlyFormField;
